module.exports = __webpack_public_path__ + "static/img/parallax2.745952ac.jpg";